<template>
  <modal :show="localShow" @close="close">
    <v-flex class="ma-1" slot="title">{{ id ? 'Edytuj kartę' : 'Dodaj kartę' }}</v-flex>

    <div>
      <w-schema :model="$schema.number">
        <v-text-field name="name" label="Numer karty"></v-text-field>
      </w-schema>

      <v-text-field name="name" label="Użytkownik karty" readonly v-model="cardOwner"></v-text-field>

      <w-select
        item-text="text"
        item-value="value"
        label="Status karty*"
        :items="statuses"
        :model="$schema.state"
      ></w-select>
    </div>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import { WSchema, WSelect, schemaMixin } from '@witkac/vuetify-components';
import { CardState, CardStateTranslation } from '@witkac/kartamiejska-shared';

import Modal from '@/components/material/Modal';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/card.schema';

// @vuese
// Modal dodawnia/edycji karty klienta
// @group Client-Profile
export default {
  schema,
  props: {
    // Boolean kontrolujący widoczność modala
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    // Identyfikator edytowanej encji
    id: {
      type: Number,
      required: false,
      default: undefined
    },
    // Id profilu do którego przypisana ma być karta
    profileId: {
      type: Number,
      required: true
    }
  },
  mixins: [schemaMixin, notificationsMixin],
  components: { WSchema, WSelect, Modal },
  data() {
    return {
      emptyModel: {
        state: '',
        number: '',
        profileId: null
      },
      statuses: [
        {
          text: CardStateTranslation[CardState.NOT_CONFIRMED],
          value: CardState[CardState.NOT_CONFIRMED]
        },
        {
          text: CardStateTranslation[CardState.ORDERED],
          value: CardState[CardState.ORDERED]
        },
        {
          text: CardStateTranslation[CardState.READY],
          value: CardState[CardState.READY]
        },
        {
          text: CardStateTranslation[CardState.ACTIVE],
          value: CardState[CardState.ACTIVE]
        },
        {
          text: CardStateTranslation[CardState.INACTIVE],
          value: CardState[CardState.INACTIVE]
        }
      ],
      model: { ...this.emptyModel }
    };
  },
  methods: {
    // @vuese
    // Potwierdzenie zamknięcia formularza w przypadku zmian
    close() {
      if (this.$schema.$dirtyList().length !== 0) {
        this.$store.dispatch('showConfirmDialog');
      } else {
        this.closeModal();
      }
    },
    // @vuese
    // Funkcja emituje event `close` do zamknięcia modalu
    closeModal() {
      // Zamyka modal
      this.$emit('close');
    },
    // @vuese
    // Funkcja zapisuje/edytuje kartę przypisaną do użytkownika
    save() {
      if (!this.$schema.$validateAll().length) {
        if (!this.id) {
          this.$store
            .dispatch('client/cards/add', { ...this.model })
            .then(() => {
              this.notifySuccess('Dodano kartę');
              this.closeModal();
            })
            .catch(error => this.notifyError(error.message));
        } else {
          this.$store
            .dispatch('client/cards/update', { id: this.id, ...this.model })
            .then(() => {
              this.notifySuccess('Zapisano kartę');
              this.closeModal();
            })
            .catch(error => this.notifyError(error.message));
        }
      } else {
        this.notifyError('Błędnie wypełniony formularz.');
      }
    },

    // @vuese
    // Ustawia dane formularza
    setData() {
      this.$schema.$setData(this.id ? this.$store.getters['client/cards/byId'](this.id) : { ...this.emptyModel });
      this.$schema.$reset();
      this.$schema.profileId.$model = this.profileId;
    }
  },
  computed: {
    localShow() {
      return this.show;
    },
    ...mapState({
      cardOwner: state => state.client.data.profile.firstName + ' ' + state.client.data.profile.lastName
    })
  },
  watch: {
    show(val) {
      if (val) {
        this.setData();
      }
    }
  }
};
</script>
